import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;
const SYS = Global.system;

class VacationService {
    async downloadBallotByid(papeletaID) {
        const ruta = `${API_URL}/vacation/download_papeleta/${papeletaID}`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers,
            responseType: 'blob'
        });
    }

    CreateBallot = async (formData) => {
        const ruta = `${API_URL}/vacation/CreateBallot`;
        const headers = await headerRequest();
        const response = await axios.post(ruta, formData, { headers });
        return response.data;
    };

    sendToken = async (formData) => {
        const ruta = `${API_URL}/vacation/send-token`;
        const headers = await headerRequest();
        const response = await axios.post(ruta, formData, { headers });
        return response.data;
    };

    async approveToken(formData, id_papeleta) {
        const ruta = `${API_URL}/vacation/aprobar/${id_papeleta}`;
        const headers = await headerRequest();
        return axios.post(ruta, formData, { headers })
    }

    UpdateBallot = async (formData) => {
        const ruta = `${API_URL}/vacation/UpdateBallot`;
        const headers = await headerRequest();
        return axios.put(ruta, formData, { headers });
    };

    async Myballots(id) {
        const ruta = `${API_URL}/vacation/GetBallots?id=${id}`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers
        })
    }

    async GetBallotsByPersona(id) {
        const ruta = `${API_URL}/vacation/GetBallotsByPersona/${id}`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers
        })
    }

    async GetMySubordinates(id) {
        const ruta = `${API_URL}/vacation/GetMySubordinates/${id}`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers
        })
    }

    async ballotsSubordinates(id) {
        const ruta = `${API_URL}/vacation/GetBallots?id=${id}&subordinates=1`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers
        })
    }

    async GenerateBallotData(id_persona) {
        const ruta = `${API_URL}/vacation/GenerateBallot`;
        const headers = await headerRequest();
        const payload = { id_persona };
        return axios.post(ruta, payload, { headers });
    }

    async CalculateSlopes(id_persona) {
        const ruta = `${API_URL}/vacation/CalcularPendientes`;
        const headers = await headerRequest();
        const payload = { id_persona };
        return axios.post(ruta, payload, { headers });
    }

    //gestion de todas las papeletas para RRHH:

    async GetApprovedBallotsByClient(cliente_id, campo_fecha, startDate, endDate, page = 1, nombre = '') {
        const ruta = `${API_URL}/vacation/GetApprovedBallotsByClient?page=${page}`;
        const headers = await headerRequest();
        const body = { cliente_id, campo_fecha, startDate, endDate, nombre };
        return axios.post(ruta, body, { headers });
    }

    async GetAproveBallotsByPersona(id) {
        const ruta = `${API_URL}/vacation/GetBallotsByPersona/${id}?solo_aprobadas=1`;
        const headers = await headerRequest();
        return axios.get(ruta, { headers });
    }

    async massiveDownloadByIds(ids) {
        const ruta = `${API_URL}/vacation/massiveDownloadByIds`;
        const headers = await headerRequest();
        return axios.post(ruta, { ids }, {
            headers: headers,
            responseType: 'blob'
        });
    }

    //gestion de papeletas masivas:

    getAgrupamientoByUsuario(url, id) {
        const ruta = `${API_URL}/user/user/grouping/${id}?sys=${SYS}&url=${url}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new VacationService();